// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/purchasehistory/v1/legacy_portal_common.proto (package spwn.purchasehistory.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * 注文の取得元
 *
 * @generated from enum spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderSource
 */
export var LegacyPortalPurchaseHistoryOrderSource;
(function (LegacyPortalPurchaseHistoryOrderSource) {
    /**
     * 未指定
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_SOURCE_UNSPECIFIED = 0;
     */
    LegacyPortalPurchaseHistoryOrderSource[LegacyPortalPurchaseHistoryOrderSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * SPWN決済（Firestore settlement）
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_SOURCE_SPWN = 1;
     */
    LegacyPortalPurchaseHistoryOrderSource[LegacyPortalPurchaseHistoryOrderSource["SPWN"] = 1] = "SPWN";
    /**
     * SPWN EC Shopifyストア（RDB shopify_order）
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_SOURCE_SHOPIFY = 2;
     */
    LegacyPortalPurchaseHistoryOrderSource[LegacyPortalPurchaseHistoryOrderSource["SHOPIFY"] = 2] = "SHOPIFY";
})(LegacyPortalPurchaseHistoryOrderSource || (LegacyPortalPurchaseHistoryOrderSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalPurchaseHistoryOrderSource)
proto3.util.setEnumType(LegacyPortalPurchaseHistoryOrderSource, "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderSource", [
    { no: 0, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_SOURCE_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_SOURCE_SPWN" },
    { no: 2, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_SOURCE_SHOPIFY" },
]);
/**
 * 注文状態。SPWN決済とShopify注文で共通の語彙
 *
 * @generated from enum spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderStatus
 */
export var LegacyPortalPurchaseHistoryOrderStatus;
(function (LegacyPortalPurchaseHistoryOrderStatus) {
    /**
     * 未指定（実データに存在する未知の値もここに落とす）
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalPurchaseHistoryOrderStatus[LegacyPortalPurchaseHistoryOrderStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未払い
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_UNPROCESS = 1;
     */
    LegacyPortalPurchaseHistoryOrderStatus[LegacyPortalPurchaseHistoryOrderStatus["UNPROCESS"] = 1] = "UNPROCESS";
    /**
     * 決済完了
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_PAYSUCCESS = 2;
     */
    LegacyPortalPurchaseHistoryOrderStatus[LegacyPortalPurchaseHistoryOrderStatus["PAYSUCCESS"] = 2] = "PAYSUCCESS";
    /**
     * キャンセル
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_CANCEL = 3;
     */
    LegacyPortalPurchaseHistoryOrderStatus[LegacyPortalPurchaseHistoryOrderStatus["CANCEL"] = 3] = "CANCEL";
    /**
     * 返金
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_RETURN = 4;
     */
    LegacyPortalPurchaseHistoryOrderStatus[LegacyPortalPurchaseHistoryOrderStatus["RETURN"] = 4] = "RETURN";
})(LegacyPortalPurchaseHistoryOrderStatus || (LegacyPortalPurchaseHistoryOrderStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalPurchaseHistoryOrderStatus)
proto3.util.setEnumType(LegacyPortalPurchaseHistoryOrderStatus, "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderStatus", [
    { no: 0, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_UNPROCESS" },
    { no: 2, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_PAYSUCCESS" },
    { no: 3, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_CANCEL" },
    { no: 4, name: "LEGACY_PORTAL_PURCHASE_HISTORY_ORDER_STATUS_RETURN" },
]);
/**
 * 商品種別
 *
 * @generated from enum spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryProductType
 */
export var LegacyPortalPurchaseHistoryProductType;
(function (LegacyPortalPurchaseHistoryProductType) {
    /**
     * 未指定
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_PRODUCT_TYPE_UNSPECIFIED = 0;
     */
    LegacyPortalPurchaseHistoryProductType[LegacyPortalPurchaseHistoryProductType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * チケット
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_PRODUCT_TYPE_TICKET = 1;
     */
    LegacyPortalPurchaseHistoryProductType[LegacyPortalPurchaseHistoryProductType["TICKET"] = 1] = "TICKET";
    /**
     * グッズ
     *
     * @generated from enum value: LEGACY_PORTAL_PURCHASE_HISTORY_PRODUCT_TYPE_GOODS = 2;
     */
    LegacyPortalPurchaseHistoryProductType[LegacyPortalPurchaseHistoryProductType["GOODS"] = 2] = "GOODS";
})(LegacyPortalPurchaseHistoryProductType || (LegacyPortalPurchaseHistoryProductType = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalPurchaseHistoryProductType)
proto3.util.setEnumType(LegacyPortalPurchaseHistoryProductType, "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryProductType", [
    { no: 0, name: "LEGACY_PORTAL_PURCHASE_HISTORY_PRODUCT_TYPE_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_PURCHASE_HISTORY_PRODUCT_TYPE_TICKET" },
    { no: 2, name: "LEGACY_PORTAL_PURCHASE_HISTORY_PRODUCT_TYPE_GOODS" },
]);
/**
 * 購入履歴がある年と、その年の注文件数
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryAvailableYear
 */
export class LegacyPortalPurchaseHistoryAvailableYear extends Message {
    constructor(data) {
        super();
        /**
         * 年
         *
         * @generated from field: int32 year = 1;
         */
        this.year = 0;
        /**
         * その年の注文件数
         *
         * @generated from field: int32 count = 2;
         */
        this.count = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryAvailableYear().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryAvailableYear().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryAvailableYear().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryAvailableYear, a, b);
    }
}
LegacyPortalPurchaseHistoryAvailableYear.runtime = proto3;
LegacyPortalPurchaseHistoryAvailableYear.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryAvailableYear";
LegacyPortalPurchaseHistoryAvailableYear.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 購入履歴の注文。一覧・注文詳細・領収書で共用する
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrder
 */
export class LegacyPortalPurchaseHistoryOrder extends Message {
    constructor(data) {
        super();
        /**
         * 取得元
         *
         * @generated from field: spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderSource source = 1;
         */
        this.source = LegacyPortalPurchaseHistoryOrderSource.UNSPECIFIED;
        /**
         * 注文番号。SPWNはFirestoreのdocument ID、Shopifyは注文時点の注文名（例: "#SW1042"）。注文詳細の取得キーになる
         *
         * @generated from field: string order_id = 2;
         */
        this.orderId = "";
        /**
         * 画面に表示する注文番号。SPWNはorderId、Shopifyは注文時点の注文名（例: "#SW1042"）
         *
         * @generated from field: string display_order_number = 3;
         */
        this.displayOrderNumber = "";
        /**
         * 注文状態
         *
         * @generated from field: spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderStatus status = 4;
         */
        this.status = LegacyPortalPurchaseHistoryOrderStatus.UNSPECIFIED;
        /**
         * 合計（税込）
         *
         * @generated from field: int32 total_price = 10;
         */
        this.totalPrice = 0;
        /**
         * 送料
         *
         * @generated from field: int32 shipping_fee = 11;
         */
        this.shippingFee = 0;
        /**
         * 購入点数の合計
         *
         * @generated from field: int32 purchased_count = 16;
         */
        this.purchasedCount = 0;
        /**
         * 明細
         *
         * @generated from field: repeated spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderItem items = 17;
         */
        this.items = [];
        /**
         * 配送（出庫）情報のFirestore ID。SPWN注文のみ。配送状況はLegacyPortalShippingServiceで取得する
         *
         * @generated from field: repeated string fulfillment_firestore_ids = 18;
         */
        this.fulfillmentFirestoreIds = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryOrder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryOrder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryOrder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryOrder, a, b);
    }
}
LegacyPortalPurchaseHistoryOrder.runtime = proto3;
LegacyPortalPurchaseHistoryOrder.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrder";
LegacyPortalPurchaseHistoryOrder.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "source", kind: "enum", T: proto3.getEnumType(LegacyPortalPurchaseHistoryOrderSource) },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(LegacyPortalPurchaseHistoryOrderStatus) },
    { no: 5, name: "pay_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "purchased_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 8, name: "cancelled_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 9, name: "refunded_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 10, name: "total_price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "shipping_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "service_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "settlement_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 14, name: "subtotal_price", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 15, name: "discount_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 16, name: "purchased_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "items", kind: "message", T: LegacyPortalPurchaseHistoryOrderItem, repeated: true },
    { no: 18, name: "fulfillment_firestore_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 19, name: "shipping_unique_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 20, name: "shipping_address", kind: "message", T: LegacyPortalPurchaseHistoryShippingAddress, opt: true },
    { no: 21, name: "unpaid_payment_info", kind: "message", T: LegacyPortalPurchaseHistoryUnpaidPaymentInfo, opt: true },
]);
/**
 * 注文明細
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderItem
 */
export class LegacyPortalPurchaseHistoryOrderItem extends Message {
    constructor(data) {
        super();
        /**
         * 商品名
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * 購入時点の税込単価
         *
         * @generated from field: int32 price = 3;
         */
        this.price = 0;
        /**
         * 数量
         *
         * @generated from field: int32 quantity = 4;
         */
        this.quantity = 0;
        /**
         * 商品種別
         *
         * @generated from field: spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryProductType product_type = 6;
         */
        this.productType = LegacyPortalPurchaseHistoryProductType.UNSPECIFIED;
        /**
         * @generated from oneof spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderItem.detail
         */
        this.detail = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryOrderItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryOrderItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryOrderItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryOrderItem, a, b);
    }
}
LegacyPortalPurchaseHistoryOrderItem.runtime = proto3;
LegacyPortalPurchaseHistoryOrderItem.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryOrderItem";
LegacyPortalPurchaseHistoryOrderItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "price", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "eid", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "product_type", kind: "enum", T: proto3.getEnumType(LegacyPortalPurchaseHistoryProductType) },
    { no: 7, name: "event", kind: "message", T: LegacyPortalPurchaseHistoryEvent, opt: true },
    { no: 8, name: "spwn", kind: "message", T: LegacyPortalPurchaseHistorySpwnItem, oneof: "detail" },
    { no: 9, name: "shopify", kind: "message", T: LegacyPortalPurchaseHistoryShopifyItem, oneof: "detail" },
]);
/**
 * SPWN決済の明細固有情報
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistorySpwnItem
 */
export class LegacyPortalPurchaseHistorySpwnItem extends Message {
    constructor(data) {
        super();
        /**
         * 商品のFirestore ID。チケットの場合はチケットIDとして使う
         *
         * @generated from field: string product_firestore_id = 1;
         */
        this.productFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistorySpwnItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistorySpwnItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistorySpwnItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistorySpwnItem, a, b);
    }
}
LegacyPortalPurchaseHistorySpwnItem.runtime = proto3;
LegacyPortalPurchaseHistorySpwnItem.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistorySpwnItem";
LegacyPortalPurchaseHistorySpwnItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "product_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "class", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "sub_class_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "event_long_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * Shopify注文の明細固有情報
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryShopifyItem
 */
export class LegacyPortalPurchaseHistoryShopifyItem extends Message {
    constructor(data) {
        super();
        /**
         * 明細単位の値引き額
         *
         * @generated from field: int32 discount_amount = 2;
         */
        this.discountAmount = 0;
        /**
         * 明細単位の返金額
         *
         * @generated from field: int32 refunded_amount = 3;
         */
        this.refundedAmount = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryShopifyItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryShopifyItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryShopifyItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryShopifyItem, a, b);
    }
}
LegacyPortalPurchaseHistoryShopifyItem.runtime = proto3;
LegacyPortalPurchaseHistoryShopifyItem.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryShopifyItem";
LegacyPortalPurchaseHistoryShopifyItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "variant_title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "discount_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "refunded_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 明細に紐づくイベント情報
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryEvent
 */
export class LegacyPortalPurchaseHistoryEvent extends Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string eid = 1;
         */
        this.eid = "";
        /**
         * 公演（部）の一覧
         *
         * @generated from field: repeated spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryEventPart parts = 4;
         */
        this.parts = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryEvent, a, b);
    }
}
LegacyPortalPurchaseHistoryEvent.runtime = proto3;
LegacyPortalPurchaseHistoryEvent.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryEvent";
LegacyPortalPurchaseHistoryEvent.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "eid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "banner_image_path", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "default_image", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "parts", kind: "message", T: LegacyPortalPurchaseHistoryEventPart, repeated: true },
]);
/**
 * 公演（部）
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryEventPart
 */
export class LegacyPortalPurchaseHistoryEventPart extends Message {
    constructor(data) {
        super();
        /**
         * 名称
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * 開場日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 open_time = 2;
         */
        this.openTime = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryEventPart().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryEventPart().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryEventPart().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryEventPart, a, b);
    }
}
LegacyPortalPurchaseHistoryEventPart.runtime = proto3;
LegacyPortalPurchaseHistoryEventPart.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryEventPart";
LegacyPortalPurchaseHistoryEventPart.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * 決済時の配送先住所スナップショット
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryShippingAddress
 */
export class LegacyPortalPurchaseHistoryShippingAddress extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryShippingAddress().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryShippingAddress().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryShippingAddress().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryShippingAddress, a, b);
    }
}
LegacyPortalPurchaseHistoryShippingAddress.runtime = proto3;
LegacyPortalPurchaseHistoryShippingAddress.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryShippingAddress";
LegacyPortalPurchaseHistoryShippingAddress.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "company", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "zip", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "country_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "province", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "province_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "address1", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "address2", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 12, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * 未払い注文の支払案内（コンビニ・キャリア・PayPal）
 *
 * @generated from message spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryUnpaidPaymentInfo
 */
export class LegacyPortalPurchaseHistoryUnpaidPaymentInfo extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalPurchaseHistoryUnpaidPaymentInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalPurchaseHistoryUnpaidPaymentInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalPurchaseHistoryUnpaidPaymentInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalPurchaseHistoryUnpaidPaymentInfo, a, b);
    }
}
LegacyPortalPurchaseHistoryUnpaidPaymentInfo.runtime = proto3;
LegacyPortalPurchaseHistoryUnpaidPaymentInfo.typeName = "spwn.purchasehistory.v1.LegacyPortalPurchaseHistoryUnpaidPaymentInfo";
LegacyPortalPurchaseHistoryUnpaidPaymentInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "convenience", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "receipt_no", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "conf_no", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "phone_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "phone_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "paypal_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "error_info", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map